export const ALLOWED_FIELDS = {
  'verificator': {
    14: [
      '3.3.',
      '3.4.',
      '3.5.',
      '3.6.',
      '3.7.',
      '4.1.',
      '4.2.',
      '4.3.',
      '4.4.',
      '4.5.',
      '5.1.',
      '5.3.',
      '5.4.',
      '6.1.',
      '7.1.',
      '7.2.',
      '7.3.',
      '7.4.',
      '7.5.',
      '7.6.'
    ]
  }
};
